<template>
	<div class="flex-box">
		<div class="search-box">
			<div v-if="$hasPermission('A10301')">
				<label style="width: auto;" class="searchItemName">渠道：</label>
				<el-select v-model="SelectChannelId" clearable placeholder="筛选渠道">
					<el-option v-for="item in options" :key="item.id" :label="item.channelName" :value="item.id">
					</el-option>
				</el-select>
			</div>

			<div>
				<label class="searchItemName">设备号：</label>
				<el-input class="input-box" placeholder="筛选设备号后四位" v-model="queryParams.deviceCode" clearable>
				</el-input>
			</div>
			
			<div>
				<label class="searchItemName" style="width: 130px;">拍照人姓名：</label>
				<el-input class="input-box" placeholder="姓名" v-model="queryParams.idName" clearable>
				</el-input>
			</div>

			<div>
				<label class="searchItemName" style="width: 120px;">身份证后6位：</label>
				<el-input class="input-box" placeholder="身份证后6位" v-model="queryParams.idNumber" clearable maxlength="6" style="width: 150px;">
				</el-input>
			</div>

			<div>
				<label class="searchItemName">拍摄日期：</label>
				<el-date-picker v-model="dateRange" type="daterange" align="right" unlink-panels range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
				</el-date-picker>
			</div>
			<el-button style="margin-left: 10px;" type="primary" v-on:click="GetData()" icon="el-icon-search">查询</el-button>
			<!-- <el-button style="margin-left: 10px;" type="primary" v-on:click="$alert('测试')">测试</el-button> -->
		</div>
		<!--数据表格-->
		<div>
			<el-table :data="tableData" border style="width: 100%;margin: 15px 0px;">
				<el-table-column prop="deviceCode" label="设备编号" width="120" align="center">
					<template slot-scope="scope">
						<span class="copyable-cell" :title="'双击复制：' + scope.row.deviceCode" @dblclick="copyToClipboard(scope.row.deviceCode)">{{ scope.row.deviceCode }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="channelName" label="渠道名称" width="140" align="center">
				</el-table-column>
				<el-table-column label="证件信息" width="180" align="center">
					<template slot-scope="scope">
						<label>{{scope.row.idName}}</label>
						<br />
						<label>{{scope.row.idNumber.substring(0, 4)+"****"+scope.row.idNumber.substring(12)}}</label>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="idName" label="姓名" width="120" align="center">
				</el-table-column>
				<el-table-column prop="idNumber" label="证件号码" width="180" align="center">
				</el-table-column> -->
				<el-table-column prop="authority" label="发证机关" width="100" align="center">
				</el-table-column>
				<el-table-column prop="photo" label="相片" width="120" align="center">
					<template slot-scope="scope">
						<img
							:src="scope.row.photo"
							class="photo-thumb"
							@click="previewPhoto(scope.row.photo)"
						/>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="体检时间" width="160" align="center">
				</el-table-column>
				<el-table-column prop="submitTime" label="提交时间" width="160" align="center">
				</el-table-column>
				<el-table-column prop="photoType" label="相片类型" width="100" align="center">
					<template slot-scope="scope">
						<el-tag :type="''"
							disable-transitions>{{scope.row.photoType === 1 ? '体检':(scope.row.photoType === 2 ?'体检+拍照':(scope.row.photoType === 3 ?'拍照':(scope.row.photoType === 4 ?'回执照':(scope.row.photoType === 5 ?'证件照':'未知'))))}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="isSubmit" label="是否需要提交" width="90" align="center">
					<template slot-scope="scope">
						<el-tag :type="scope.row.isSubmit ? 'success' : 'info'"
							disable-transitions>{{scope.row.isSubmit ? '是':'否'}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="提交状态" width="100" align="center">
					<template slot-scope="scope">
						<el-tag
							:type="scope.row.status === 0 ? 'info' : (scope.row.status === 1 ?'success':'danger')"
							disable-transitions>{{scope.row.status === 0 ? '未提交' : (scope.row.status === 1 ?'提交成功':'提交失败')}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="resultJson" label="接口响应内容" width="160" align="center">
				</el-table-column>
				<el-table-column prop="reason" label="失败原因" width="160" align="center">
				</el-table-column>
				<el-table-column prop="payStatus" label="支付状态" width="100" align="center">
					<template slot-scope="scope">
						<el-tag
							:type="scope.row.payStatus === 0 ? 'info' : (scope.row.payStatus === 1 ?'success':'')"
							disable-transitions>{{scope.row.payStatus === 0 ? '未支付' : (scope.row.payStatus === 1 ?'支付成功':'免费')}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="payOrderId" label="支付订单id" width="160" align="center">
				</el-table-column>
				<el-table-column prop="valid" label="是否篡改" width="100" align="center">
					<template slot-scope="scope">
						<el-tag :type="scope.row.valid === false ? 'danger' : 'success'"
							disable-transitions>{{scope.row.valid === false ? '是':'否'}}</el-tag>
					</template>
				</el-table-column>
				
				<el-table-column prop="address" label="操作" align="center" min-width="190">
					<template slot-scope="scope">
						<!-- <el-button type="primary" size="mini" plain v-on:click="DetailsInformation(scope.row)">---</el-button>
						<el-button type="success" size="mini" plain v-on:click="toExamine(scope.row)">---</el-button> -->
						<el-button type="warning" size="mini" plain v-on:click="resubmit(scope.row)">重新提交</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div>
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="queryParams.pageIndex" :page-sizes="[10, 20, 30, 40, 50]"
				:page-size="queryParams.pageSize" layout="sizes, prev, pager, next" :total="total">
			</el-pagination>
		</div>
		<el-dialog title="相片预览" :visible.sync="photoDialogVisible" width="50%" @close="photoDialogVisible=false">
			<div class="photo-preview-wrapper" v-if="currentPhotoUrl">
				<img :src="currentPhotoUrl" class="photo-preview" />
			</div>
			<div v-else class="photo-preview-placeholder">暂无图片</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="photoDialogVisible=false">关闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {post} from '../../../../public/request/request.js';
	export default {
		data() {
			return {
				/**
				 * 数据总条数
				 */
				total: 0,
				/**
				 * 接口查询参数
				 */
				queryParams: {
					/**
					 * 当前页码
					 */
					pageIndex: 1,
					/**
					 * 每页条数
					 */
					pageSize: 10,
					/**
					 * 渠道id
					 */
					channelId: 0,
					/**
					 * 设备号
					 */
					deviceCode: "",
					/**
					 * 体检人姓名
					 */
					idName: "",
					/**
					 * 身份证后6位
					 */
					idNumber: "",
					/**
					 * 开始日期,拍摄日期
					 */
					beginTime: '',
					/**
					 * 结束日期
					 */
					endTime: '',
				},
				/**
				 * 渠道下拉框
				 */
				options: [],
				/**
				 * 日期框快捷选项
				 */
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				/**
				 * 数据表格
				 */
				tableData: [],
				photoDialogVisible: false,
				currentPhotoUrl: ''
			}
		},
		/**
		 * 方法
		 */
		methods: {
			/**
			 * 双击复制到剪切板
			 */
			copyToClipboard(text) {
				const value = text == null ? '' : String(text).trim();
				if (!value) {
					this.$message.warning('无内容可复制');
					return;
				}
				const done = () => {
					this.$message.success('已复制到剪切板');
				};
				const fail = () => {
					this.$message.error('复制失败，请手动复制');
				};
				if (navigator.clipboard && navigator.clipboard.writeText) {
					navigator.clipboard.writeText(value).then(done).catch(() => {
						this.copyToClipboardFallback(value) ? done() : fail();
					});
					return;
				}
				this.copyToClipboardFallback(value) ? done() : fail();
			},
			copyToClipboardFallback(text) {
				try {
					const textarea = document.createElement('textarea');
					textarea.value = text;
					textarea.setAttribute('readonly', '');
					textarea.style.position = 'fixed';
					textarea.style.left = '-9999px';
					document.body.appendChild(textarea);
					textarea.select();
					const ok = document.execCommand('copy');
					document.body.removeChild(textarea);
					return ok;
				} catch (e) {
					return false;
				}
			},
			/**
			 * 获取数据列表
			 */
			GetData() {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.4)'
				});

				// 查询拍照信息数据列表
				post('404', this.queryParams)
					.then(response => {
						if (response.data.result == 0) {
							this.tableData = response.data.data.list;
							this.total = response.data.data.pageCount * this.queryParams.pageSize;
							loading.close();
						} else {
							this.$message.error('查询数据失败:' + response.data.message);
						}
					})
					.catch(error => {
						this.$message.error((error && error.userMessage) || '查询数据失败');
					});
			},
			/**
			 * 获取渠道数据
			 */
			GetChannelData() {
				// 检查是否允许获取渠道数据
				const allowChannel = sessionStorage.getItem('allowChannel');
				if (allowChannel === 'false') {
					return; // 不允许获取渠道，直接返回
				}
				// 获取渠道数据列表
				post('208', {
						channelName: ''
					})
					.then(response => {
						if (response.data.result == 0) {
							this.options = response.data.data;
						} else {
							this.$message.error('获取渠道失败:' + response.data.message);
						}
					})
					.catch(error => {
						this.$message.error((error && error.userMessage) || '获取渠道失败');
					});
			},
			/**
			 * 页码切换事件
			 */
			handleCurrentChange(pageIndex) {
				this.GetData();
			},
			/**
			 * 每页大小切换事件
			 */
			handleSizeChange(size) {
				this.queryParams.pageSize = size;
			},
			/**
			 * 日期转yyyy-MM-dd
			 * @param {Object} today日期
			 */
			dataToString(today) {
				let year = today.getFullYear();
				let month = (today.getMonth() + 1).toString().padStart(2, '0');
				let day = today.getDate().toString().padStart(2, '0');
				return `${year}-${month}-${day}`;
			},
			/**
			 * 打开加载遮罩
			 */
			openLoading() {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.4)'
				});
				return loading;
			},
			/**
			 * 详情信息
			 */
			DetailsInformation(model){
				this.$alert(JSON.stringify(model),"详情信息");
			},
			/**
			 * 审核
			 */
			toExamine(model){
				this.$alert(JSON.stringify(model),"审核");
			},
			/**
			 * 重新提交
			 */
			resubmit(model){
				this.$confirm('确定重新提交吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					const loading = this.openLoading();
					// 重新提交
					post('407', {id:model.id})
						.then(response => {
							if (response.data.result == 0) {
								this.$message.success('重新提交成功:' + response.data.message);
								loading.close();
							} else {
								this.$message.error('重新提交失败：' + response.data.message);
								loading.close();
							}
						})
						.catch(error => {
							this.$message.error((error && error.userMessage) || '重新提交失败');
							loading.close();
						});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消操作'
					});
				});
			},
			previewPhoto(url){
				if(!url){
					this.$message.error('暂无图片');
					return;
				}
				this.currentPhotoUrl = url;
				this.photoDialogVisible = true;
			}
		},
		/**
		 * 加载完成事件
		 */
		mounted() {
			this.GetChannelData();
			this.GetData();
		},
		/**
		 * 计算属性
		 */
		computed: {
			/**
			 * 日期范围选择框
			 */
			dateRange: {
				get() {
					if (this.queryParams.beginTime == "" || this.queryParams.endTime == "") {
						const today = new Date();
						let year = today.getFullYear();
						let month = (today.getMonth() + 1).toString().padStart(2, '0');
						let day = today.getDate().toString().padStart(2, '0');
						this.queryParams.beginTime = `${year}-${month}-${day}`;
						this.queryParams.endTime = `${year}-${month}-${day}`;
					}
					return [new Date(Date.parse(this.queryParams.beginTime)), new Date(Date.parse(this.queryParams
						.endTime))];
				},
				set(value) {
					if (value == null) {
						const today = new Date();
						let year = today.getFullYear();
						let month = (today.getMonth() + 1).toString().padStart(2, '0');
						let day = today.getDate().toString().padStart(2, '0');
						this.queryParams.beginTime = `${year}-${month}-${day}`;
						this.queryParams.endTime = `${year}-${month}-${day}`;
					} else {
						this.queryParams.beginTime = this.dataToString(value[0]);
						this.queryParams.endTime = this.dataToString(value[1]);
					}
				}
			},
			/**
			 * 选择的渠道id
			 */
			SelectChannelId: {
				get() {
					if (this.queryParams.channelId == 0) {
						return '';
					} else {
						return this.queryParams.channelId;
					}
				},
				set(value) {
					if (value == '') {
						this.queryParams.channelId = 0;
					} else {
						this.queryParams.channelId = value;
					}
				}
			}
		}
	}
</script>

<style>
	.flex-box {
		display: flex;
		flex-direction: column;
	}

	.search-box {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
	}

	.searchItemName {
		width: 100px;
		text-align: right;
		display: inline-block;
	}

	.input-box {
		width: 200px;
	}

	.copyable-cell {
		cursor: copy;
		user-select: none;
	}
	
	.photo-thumb {
		width: 100%;
		max-width: 60px;
		height: 80px;
		object-fit: cover;
		cursor: pointer;
		border-radius: 4px;
		transition: transform 0.2s ease;
	}
	
	.photo-thumb:hover {
		transform: scale(1.05);
	}
	
	.photo-preview-wrapper {
		display: flex;
		justify-content: center;
		align-items: center;
		max-height: 70vh;
	}
	
	.photo-preview {
		max-width: 100%;
		max-height: 70vh;
		object-fit: contain;
		border-radius: 8px;
	}
	
	.photo-preview-placeholder {
		text-align: center;
		color: #999;
		padding: 40px 0;
	}
</style>